module.exports = __webpack_public_path__ + "img/mpeg.213845da.svg";